import { v4 as uuidv4 } from 'uuid';

export const getJobId = () => {
    return uuidv4();
};
